import axios from "axios";

export { default as SomaPlace } from "../SomaPlace/SomaPlace";

const DEFALT_BASE_URL_SOMAPLACE = "http://34.121.180.230:3000/";
// const DEFALT_BASE_URL_SOMAPLACE = "http://localhost:3000/";

export default axios.create({
  baseURL: DEFALT_BASE_URL_SOMAPLACE,
  transformRequest: [
    (data, headers) => {
      const token = localStorage.getItem("CurUser");
      if (token) {
        headers.common.Authorization = `Bearer ${token}`;
      } else {
        console.log("Necessário Login");
      }
      return data;
    },
    ...axios.defaults.transformRequest,
  ],
});
